import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import parceiroManager from '../../services/api/parceiro/parceiroManager'
import { Parceiro } from '../../types/parceiroApiTypes'
import { SelecaoParceiroExecucaoCicloProps } from './SelecaoParceiroExecucaoCiclo.View'
import { selecaoParceiroExecucaoCicloStyles } from './SelecaoParceiroExecucaoCiclo.style'

export function selecaoParceiroExecucaoCicloIO({ voltarPage, pageValidarExecucao }: SelecaoParceiroExecucaoCicloProps) {
  const router = useHistory()
  const { parceiroId } = useParams<{ parceiroId: string }>()
  const [parceiros, setParceiros] = useState<Parceiro[]>([])
  const [parceiroSelecionado, setParceiroSelecionado] = useState<number>(Number(parceiroId ? parceiroId : 0))
  const [abrirModalSelecaoParceiro, setAbrirModalSelecaoParceiro] = useState<boolean>(false)

  useEffect(() => {
    const obterParceirosAtivos = async () => {
      await parceiroManager
        .buscarDadosParceiros(true)
        .then((response: Parceiro[]) => {
          setParceiros(response)
        })
        .catch((error) => {
          toast.error(error.message)
        })
        .finally()
    }

    obterParceirosAtivos()
  }, [])

  const handleIconeVoltar = () => router.push(voltarPage)

  const handleConfirmar = (dadosForm: { parceiroId: number }) => {
    setParceiroSelecionado(dadosForm.parceiroId)
    router.push(pageValidarExecucao(dadosForm.parceiroId))
  }

  const handleFecharModalSelecaoParceiro = () => {
    setAbrirModalSelecaoParceiro(false)
  }

  return {
    styles: selecaoParceiroExecucaoCicloStyles,
    parceiroSelecionado,
    setParceiroSelecionado,
    parceiros,
    parceiroLogo: parceiros.filter((parceiro) => parceiro.parceiroId === parceiroSelecionado)[0]?.logoUrl,
    parceiroNome: parceiros.filter((parceiro) => parceiro.parceiroId === parceiroSelecionado)[0]?.razaoSocial,
    handleIconeVoltar,
    router,
    handleConfirmar,
    abrirModalSelecaoParceiro,
    handleFecharModalSelecaoParceiro
  }
}

export type SelecaoParceiroExecucaoCicloIO = ReturnType<typeof selecaoParceiroExecucaoCicloIO>
